import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { KioskResource } from 'app/models/KioskResource';
import { UserListResource } from 'app/resources/user/user-list-resource';
import { UtilsService } from 'app/services/utils.service';
import { forkJoin } from 'rxjs';
import { CountyListResource } from 'app/models/CountyListResource';
import { CityListResource } from 'app/models/CityListResource';
import { CityResource } from 'app/models/CityResource';
import { CountyResource } from 'app/models/CountyResource';

@Component({
  selector: 'vbn-add-edit-kiosk',
  templateUrl: './add-edit-kiosk.component.html',
  styleUrls: ['./add-edit-kiosk.component.scss']
})
export class AddEditKioskComponent implements OnInit {

  selected_language: string;
  kiosk: KioskResource;
  kioskRid: any;
  addressParams: any;
  errorMessage: any;
  userEmail: string;
  validationForm: FormGroup;
  saveErrors: boolean = false;
  clients: UserListResource;
  selectedUserId: number;
  selectedUserEmail: string;
  countyList: CountyListResource;
  cityList: CityListResource;
  selectedCounty: any;
  selectedCity: any;
  noCounty: boolean = false;
  noCity: boolean = false;
  isClient: boolean = false;
  roleId: number;
  errorEmail: boolean = false;
  
  constructor(private router: Router, 
    private activatedRoute: ActivatedRoute,
    private service: UtilsService,
    private translate: TranslateService,
    private fb: FormBuilder,
    private _notificationService: NotificationsService) {

      this.selected_language = "ro";
      this.kiosk = new KioskResource();
      this.clients = new UserListResource();
      this.clients.users = [];
      this.countyList = new CountyListResource();
      this.cityList = new CityListResource();
      
     }

  ngOnInit() {
   
    this.getAllCounties();
    this.validationForm = this.fb.group({
      serialNo:['', [Validators.required, Validators.maxLength(50), Validators.minLength(3)]],
      location:['', [Validators.required, Validators.maxLength(50), Validators.minLength(3)]],
      postal:['', [Validators.required]],
      lat:['', [Validators.required]],
      long:['', [Validators.required]],
      companyName:['', [Validators.required]],
      notificationEmail: ['', [Validators.required]],
      nameRo:['', [Validators.required, Validators.maxLength(50), Validators.minLength(3)]],
      nameDe:[''],
      nameFr:[''],
      nameEn:[''],
     /* userEmail:['', [Validators.required]], */
    })
    this.userEmail = this.service.currentUserEmail;
    if(this.router.url != '/add-kiosk') {
      this.roleId = parseInt(localStorage.getItem("_roleId"));
      if(this.roleId === 2){
        this.isClient = true;
      }
      this.activatedRoute.params.subscribe((params: Params) => {
        if('json' in params){
          this.addressParams = JSON.parse(atob(params['json']));
          this.kioskRid = this.addressParams.kioskRid;
          this.getKioskByRid(this.kioskRid);
        }
      });
    }

    this.getClientList();
  }

  getClientList(){
		this.service.get(`/admin/user/clients/getAll`)
		.subscribe(
		response => {
		  console.log("Clients List: ", response)
      this.clients = response;
      this.selectedUserId = this.clients.users.filter(x => x.email === this.kiosk.userEmail)[0].rid;
		},
		error => this.errorMessage = <any>error);
  }
  
  getKioskByRid(rid) {
    this.service.get(`/admin/kiosk/getOne/${rid}`)
      .subscribe(
        response => {
          this.kiosk = response;
          this.selectedCounty = this.kiosk.city.county.rid;
          this.getAllCitiesByCounty(this.selectedCounty);
          this.selectedCity = this.kiosk.city.rid;
          if([11205, 11150].indexOf(this.kiosk.errorCode) > 0){
            forkJoin(
              [this.translate.get('Error'),
              this.translate.get(`Get kiosk info error - (${response.errorCode})`)]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          }
          this.getClientList();
        },
        error => this.errorMessage = <any>error);
  }

  getAllCounties() {
    this.service.get('/admin/general/getAllCounties')
      .subscribe(
        response => {
          this.countyList = response;
        },
        error => this.errorMessage = <any>error);
  }

  getAllCitiesByCounty(val) {
    this.service.get('/admin/general/getAllCitiesByCounty/' + val)
      .subscribe(
        response => {
          this.cityList = response;
        },
        error => this.errorMessage = <any>error);
  }

  fillCompanyEmail(){
    if(!this.selectedUserId){
      return;
    }
    let selectedUser =  this.clients.users.filter( x => (x.rid === this.selectedUserId) )[0];
    this.selectedUserEmail = selectedUser.email;
  }

  edit(){
    let semafor;
    if (this.selectedCounty == undefined || this.selectedCounty == null) {
      this.noCounty = true;
      semafor = true;
    } else {
      this.noCounty = false;
    }
    if (this.selectedCity == undefined || this.selectedCity == null) {
      this.noCity = true;
      semafor = true;
    } else {
      this.noCity = false;
    }
    if(!this.validationForm.valid){
      semafor = true;
    }
    if(semafor) {
      this.saveErrors = true;
      forkJoin(
        [this.translate.get('Error'),
        this.translate.get(`Required fields`)]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
      return;
    }
    let checkEmail;
      if (this.kiosk != undefined) {
        if (this.kiosk.notificationEmail != null) {
          checkEmail = this.kiosk.notificationEmail.indexOf('@');
          if (this.kiosk.notificationEmail.includes('.', checkEmail)) {
            this.errorEmail = false;
          }
          else {
            this.errorEmail = true;
            return;
          }
        }
      }
    this.kiosk.companyName =  this.clients.users.filter( x => (x.rid === this.selectedUserId) )[0].companyName;
    
    this.kiosk.userEmail =  this.clients.users.filter( x => (x.rid === this.selectedUserId) )[0].email;
    this.kiosk.city = new CityResource();
    this.kiosk.city.rid = this.selectedCity;
    this.kiosk.county = new CountyResource();
    this.kiosk.county.rid = this.selectedCounty;

    this.service.add('/admin/kiosk/edit', this.kiosk)
      .subscribe(
        response => {
          this.kiosk = response;
          if(this.kiosk.errorCode === 11151){
            forkJoin(
              [this.translate.get('Error'),
              this.translate.get(`Add Kiosk in all languages - (${this.kiosk.errorCode})`)]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          }else{
            if(this.kiosk.errorCode === 11153 ){
              forkJoin(
                [this.translate.get('Error'),
                this.translate.get(`Add Kiosk - Unknown user - (${this.kiosk.errorCode})`)]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'error')
              })
            }else{
              if(this.kiosk.errorCode === 11154 || this.kiosk.errorCode === 11155){
                  forkJoin(
                    [this.translate.get('Error'),
                    this.translate.get(`Add Kiosk error - (${this.kiosk.errorCode})`)]
                  ).subscribe((res) => {
                    this._notificationService.create(res[0], res[1], 'error')
                  })
              } else if(this.kiosk.errorCode === 11219) {
                forkJoin(
                  [this.translate.get('Error'),
                  this.translate.get('Serial no already exists')]
                ).subscribe((res) => {
                  this._notificationService.create(res[0], res[1], 'error')
                })
              }else{
                  if(this.kioskRid) {
                    forkJoin(
                      [this.translate.get('Success'),
                      this.translate.get('Kiosk was successfully edited!')]
                    ).subscribe((res) => {
                      this._notificationService.create(res[0], res[1], 'success')
                    });
                  } else {
                    forkJoin(
                      [this.translate.get('Success'),
                      this.translate.get('Kiosk was successfully created!')]
                    ).subscribe((res) => {
                      this._notificationService.create(res[0], res[1], 'success')
                    });
                  }
                  window.scrollTo(500, 0);
                  this.router.navigate(['/kiosks-list']);
              }
            }
          }
          
        },
        error => this.errorMessage = <any>error);
  }

}
